
import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

export const bodyAdd = styled.div`
display: flex ;

button{
  cursor: pointer;
}

.bottonAdd{
  display: flex ;
  border-radius: 3px ;
  background-color:gray ;
  margin-bottom: 7px ;

}

`
export const NovaDespesa = styled.div`
display: flex ;
height:100% ;
align-items: flex-end ;
`
// ------------------------------------
export const selectItem = styled.div`
display: flex ;
flex-direction: column ;
width: 100% ;


.intemSelect{
  display: flex ;
  align-items: center ;
  height: 30px ;
  font-size: 13px ;
  background-color: #30353F;
  color: white ;
  min-height: 25px ;
  cursor: pointer;
  padding-left: 5px ;
  text-transform:capitalize;
}

`
export const div3 = styled.div` 
display:flex;
flex-direction: column ;
width:100%;
color: #00D594;
align-items: center ;
`

// ------------------------------------
export const BarraPesquisa = styled.div`
  display: flex ;
  position: relative ;
  flex-direction: column ;
`
//--------------Add Pagamento----------

export const bodyModal = styled.div` 
display:flex;
flex-direction: column;
background-color:#262626;
color: ${props => props.clickComprar ? 'white' : "#00ff9d"};
font-size: 13px;
width:100vw;
height: 70vh ;
max-width:500px ;
overflow: auto ;
margin-top:5px ;
padding: 0 ;

button{
  cursor: pointer;
}

input{
  width: 95%;
  text-transform:capitalize;
  height: 18px ;
  color: white ;
  outline:none ;
  border: none ;
}
select{
    background-color:#5656f7;
    color: white;
    border-radius: 3px ;
    outline:none ;
    border: none ;
    height: 19px ;
  }

  a{
    text-decoration:none;
    color: white;
    outline:0;
    background:none;
    border:0;
    cursor: pointer;

    &:hover{
      color:#00ff9d;
      }
  }

  img{
    width:20px ;
    height:20px ;
    cursor: pointer;
  }
  .icone{
    display:flex;
    align-self:center;
    width:15px;
    height:15px;
    margin: 0 3px;
    cursor: pointer;
  }

  .btAdd{
    display: flex ;
    align-items: flex-end ;
    justify-content: center ;
    margin-left: 3px;

    button{
      display: flex ;
      color: white ;
      background-color: #5656f7 ;
      align-items: center ;
      cursor: pointer;
      border: none ;
    }
  }
  .flexCaixa{
    display: flex ;
    padding-bottom: 5px ;
    font-size:13px ;
    text-transform:capitalize;

    span{
      color: #00ff9d;
    }
    select,input{
      min-height: 23px;
    }
  }
`

// --------------------------------------
export const divLancamento = styled.div`
display: flex ;
width:100%;
flex-direction: column ;
font-size: 12px ;

.tagLista{
  height: 40vh ;
}

button{
  display: flex ;
  align-items: center ;
  height: 20px ;
  color: black ;
  cursor: pointer;
}

.intemSelect{
  display: flex ;
  align-items: center ;
  height: 30px ;
  background-color: #30353F;
  color: white ;
  min-height: 25px ;
  cursor: pointer;
  padding-left: 5px ;
  text-transform:capitalize;
};
`

//--------------------------
export const Finalizar = styled.div`
display: flex ;
width:100vw;
flex: 1 ;
max-width: 500px ;
position: absolute ;
bottom: 50px;
border-top:1px solid #5656f7;
border-bottom:1px solid #5656f7;
color: white ;
justify-content: space-around ;

.divFinal{
  display: flex ;
}
`
// --------------------------------
export const Arquivos = styled.div`
display: flex;
width:100% ;
flex-direction:column ;
align-items: center ;
border: ${props => props.ListaArquivos ? '2px solid #00ff9d' : 'none'};
border-radius: 2px ;
margin-top: 10px ;

.fechar{
  display:flex;
  color:black;
  background-color: white ;
  border-radius:3px;
  width:15px;
  height:15px;
  font-size:12px;
  justify-content:center;
  align-items:center;
  padding-bottom:1px;
  border:0;
  position:absolute;
  top:5%;
  right:5%;
  z-index:1;
  cursor: pointer;
  font-weight:600;

  &:hover{
  background-color: #f0433d;
  }

}
`
// -------------------------

export const fechar = styled.div`
  display:flex;
  color:black;
  border-radius:3px;
  font-size:13px;
  justify-content:center;
  align-items:center;
  padding-bottom:1px;
  cursor: pointer;
  font-weight:bold;
  background-color: white ;

  &:hover{
  background-color: #f0433d;
  }
`
// -------------------------
export const bodyCamera = styled.div`
display: flex ;
flex-direction: column;
width:90% ;
max-width: 500px ;
align-items:center ;
align-content: center ;

.fundoBloque{
  display: ${props => props.fundoBloque ? 'flex' : 'none'} ;
  width: 100vw;
  height: 100vh; 
  background-color: black ;
  position: fixed ;
  top:0 ;
  bottom:0 ;
  z-index: 2 ;
  };

.div01{
  display: ${props => props.stream ? 'flex' : 'none'};
  width: 100vw ;
  position: fixed ;
  top: 25px ;
  z-index: 3 ;
  justify-content: center ;
  align-items: center ;
}
.div01video{
  display: flex ;
  width: 100vw ;
  position: fixed ;
  top: 10px ;
  bottom: 0 ;
  z-index: 3 ;
  justify-content: center ;
  align-items: center ;

}
.div02{
  display: ${props => props.stream ? 'flex' : 'none'};
  position: relative ;
  width: 90vw ;
  max-width: 500px ;
  justify-content: center ;
  align-items: center ;
}

.contador{
  position: absolute ;
  top: 20px ;
  left: 20px ;  
  background: rgba(0,0,0,0.3) ;
  color: red ;
  font-weight: 500 ;
  font-size: 18px ;
  padding: 0px 8px ;
  border-radius: 4px ;
  z-index: 2 ;        
}
video{
  margin-top: 10px ;
  width: 90vw ;
  max-width: 500px ;
  border-radius: 10px ;
  object-fit: cover ;
}

button{
  cursor: pointer;
}
.capturar{
  position:fixed;
  top: 75%;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  background-color: ${props => props.parar ? '#d33737ff' : "#00ff21"};
}
`

// ----------------------------------
export const Capturadas = styled.div`
display: flex ;
gap: 10px ;
flex-wrap: wrap ;
max-width: 400px ;
justify-content: center ;
border: 1px solid #00D594 ;
background-color: #262626 ;
padding:20px 0 20px 0;


`
// ----------------------------------
export const Play = styled.div`
display: flex ;
z-index: 3 ;
width: 90vw ;
max-width: 500px;
border-radius: 10px ;
position: fixed ;
top:0 ;
bottom: 0;
flex-direction: column ;
align-items: center;
justify-content: center ;
`
// ----------------------------------
export const BoxPlay = styled.div`
display: flex ;
flex-direction: column ;
align-items: center ;
justify-content: center ;
background-color: rgba(0, 0, 0, 0.95) ;
padding: 20px ;
position: fixed ;
top: 0 ;
left: 0 ;
right: 0 ;
bottom: 0 ;
z-index: 2 ;
`
// ------------------------------------
export const box = styled.div` 
display:flex;
flex-wrap: wrap ;
width:90vw ;
max-width: 400px ;
align-items: center ;
justify-content: center ;
gap: 5px;
position: relative ;
background-color: #262626;
margin-top: 20px;

input{
  height: 25px; ;
  text-transform:uppercase;
}

@media ${breakpoints.sm} {
  flex-direction: column ;
}

button{
  display: flex ;
  background-color: white ;
  align-items: center ;
  justify-content: center ;
  color: black ;
  height: 18px ;
  margin: 2px 0;
  border: none ;
  border-radius: 3px ;
  cursor: pointer;

  &:hover{
    background-color:#00ff9d;
    }
}
`
// -----------------------------------
export const divPesq = styled.div`
display: flex ;
flex-direction: column ;
position: relative ;
width:98% ;

`
// -----------------------------------
export const divListaBD = styled.div`
display: flex ;
flex-direction: column ;
left: clamp(120px, 13vw, 155px);
margin-top:5px ;
position: fixed ;
z-index: 1;

@media ${breakpoints.sm} {
  left:20px;
}

`
// -----------------------------------
// Estilos para DataEvento
export const DataEventoContainer = styled.div`
display: flex;
margin-top: 10px;
`;

export const DataEventoModal = styled.div`
background-color: #262626;
border: 1px solid #00D594;
border-radius: 5px;
padding: clamp(15px, 4vw, 30px);
width: 85vw;
max-width: 400px;
box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);

@media (max-width: 550px) {
  width: 70vw;  
}
`;

export const DataEventoHeader = styled.div`
text-align: center;
margin-bottom: clamp(15px, 3vw, 20px);
border-bottom: 1px solid #3881ff;
padding-bottom: 10px;

span {
  color: #00D594;
  font-size: clamp(14px, 3.5vw, 18px);
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}
`;

export const DataEventoInputContainer = styled.div`
margin-bottom: clamp(15px, 3vw, 20px);
width: 100%;

span {
  color: #00D594;
  font-size: clamp(11px, 3vw, 14px);
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}
`;

export const DataEventoInput = styled.input`
width: 90%;
padding: clamp(8px, 2vw, 12px);
font-size: clamp(12px, 3vw, 16px);
border-radius: 3px;
border: ${props => props.hasError ? '2px solid #ff4444' : '1px solid #3881ff'};
background-color: #353535;
color: white;
outline: none;
height: 30px;
color-scheme: dark;
text-transform:capitalize ;

&:focus {
  border-color: #00D594;
}
`;

export const DataEventoError = styled.div`
color: #ff4444;
font-size: clamp(11px, 2.5vw, 13px);
font-weight: bold;
text-align: center;
background-color: rgba(255, 68, 68, 0.1);
padding: 10px;
border-radius: 3px;
margin-bottom: 15px;
border: 1px solid #ff4444;
`;

export const DataEventoDescription = styled.div`
width: 90%;
padding: clamp(8px, 2vw, 12px);
font-size: clamp(12px, 3vw, 16px);
border-radius: 3px;
border: 1px solid #00D594;
background-color: rgba(0, 213, 148, 0.1);
color: #00D594;
outline: none;
height: 30px;
display: flex;
align-items: center;
font-weight: 500;
cursor: pointer;
transition: all 0.3s ease;
text-transform: capitalize ;

&:hover {
  background-color: rgba(0, 213, 148, 0.2);
  border-color: #00ff9d;
}
`;

export const DataEventoButtonContainer = styled.div`
display: flex;
justify-content: center;
width: 100%;
`;

export const DataEventoButton = styled.button`
background-color: #00D594;
color: #000;
padding: clamp(8px, 2vw, 12px) clamp(15px, 4vw, 30px);
font-size: clamp(11px, 3vw, 14px);
font-weight: bold;
border: none;
border-radius: 3px;
cursor: pointer;
transition: all 0.3s ease;
min-width: 120px;
height: clamp(30px, 5vw, 40px);
align-items: center;
justify-content: center;
display: flex;

&:hover {
  background-color: #00ff9d;
  transform: translateY(-2px);
}

&:active {
  transform: translateY(0);
}
`;

// -----------------------------------
// Estilos para NarracaoEvento

export const NarracaoEventoModal = styled.div`
background-color: #262626;
border: 1px solid #00D594;
border-radius: 5px;
padding: clamp(10px, 4vw, 15px) clamp(15px, 4vw, 30px);
width: 80vw;
max-width: 400px;
box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
`;

export const TituloHeader = styled.div`
text-align: center;
margin-bottom: clamp(15px, 3vw, 20px);
border-bottom: 1px solid #3881ff;

span {
  color: #00D594;
  font-size: clamp(14px, 3.5vw, 18px);
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}
`;

export const NarracaoEventoInputContainer = styled.div`
margin-bottom: clamp(15px, 3vw, 20px);
width: 100%;

span {
  color: #00D594;
  font-size: clamp(11px, 3vw, 14px);
  display: block;
  margin-bottom: 8px;
}
`;

export const NarracaoEventoTextarea = styled.textarea`
width: 90%;
min-height: 120px;
max-height: 300px;
padding: clamp(8px, 2vw, 12px);
font-size: clamp(12px, 3vw, 14px);
border-radius: 3px;
border: ${props => props.hasError ? '2px solid #ff4444' : '1px solid #3881ff'};
background-color: #353535;
color: white;
outline: none;
resize: vertical;
font-family: inherit;
line-height: 1.5;

&:focus {
  border-color: #00D594;
}

&::placeholder {
  color: #888;
}
`;

export const NarracaoEventoCounter = styled.div`
color: #888;
font-size: clamp(10px, 2.5vw, 12px);
margin-top: 5px;
text-align: right;
width: 90%;
`;

export const NarracaoEventoError = styled.div`
color: #ff4444;
font-size: clamp(11px, 2.5vw, 13px);
font-weight: bold;
text-align: center;
background-color: rgba(255, 68, 68, 0.1);
padding: 10px;
border-radius: 3px;
margin-bottom: 15px;
border: 1px solid #ff4444;
`;

export const NarracaoEventoButtonContainer = styled.div`
display: flex;
justify-content: center;
width: 100%;
`;

export const NarracaoEventoButton = styled.button`
background-color: ${props => props.narracaoDigitada >= 100? '#00D594' : '#555555'};
color: #000;
padding: clamp(8px, 2vw, 12px) clamp(15px, 4vw, 30px);
font-size: clamp(11px, 3vw, 14px);
font-weight: bold;
border: none;
border-radius: 3px;
cursor: ${props => props.narracaoDigitada >= 100? 'pointer' : 'not-allowed'};
transition: all 0.3s ease;
min-width: 120px;
height: clamp(30px, 5vw, 40px);
align-items: center;
justify-content: center;
display: flex;

&:hover {
  background-color: ${props => props.narracaoDigitada >= 100 && '#00ff9d'};
  transform: translateY(-2px);
}

&:active {
  transform: translateY(0);
}
`;


